'use client'

import type { FileDownloadButtonProps } from '@/components/file-download-button/file-download-button.types'

import classNames from 'classnames'
import { useTranslations } from 'next-intl'

import { useFileDownloadButton } from '@/components/file-download-button/batons/use-file-download-button'
import { Button } from '@pearlconvert/ui/components/button'

import '@/components/file-download-button/styles/file-download-button.scss'

export default function FileDownloadButton(props: FileDownloadButtonProps) {
  const { children, iconLeft, className } = props
  const t = useTranslations('project-scope')
  const { status, statusIcon, isInactive, handleDownload } =
    useFileDownloadButton(props)

  return (
    <Button
      type="link"
      iconLeft={statusIcon ?? iconLeft}
      className={classNames(
        'file-download-button',
        `file-download-button--${status}`,
        className
      )}
      isLoading={status === 'preparing'}
      inactive={isInactive}
      onClick={handleDownload}
    >
      {status === 'idle' && children}
      {status === 'preparing' && t('file-download.preparing')}
      {status === 'downloaded' && t('file-download.downloaded')}
      {status === 'failed' && (
        <span>
          {t('file-download.failed')}{' '}
          <span className="file-download-button__retry">
            {t('file-download.try-again')}
          </span>
        </span>
      )}
    </Button>
  )
}
